import { sdkContextStatus } from "src/context/SDKContext"
import { useQuery, useQueryClient } from "react-query"
import axios from "src/shared/axios"

const QUERY_KEY = "chat-generation-values"

export type ChatGenerationValue = {
  cgvId?: number
  customerAvatarId: number
  ownerId: number
  generation: number
}

export function useChatGenerationValues() {
  const queryClient = useQueryClient()

  const getChatGenerationValues = () => {
    const { data } = useQuery({
      queryKey: [QUERY_KEY],
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      queryFn: async () => {
        const meetingClient = await sdkContextStatus
        const url = new URL(meetingClient?.envConfig.CHAT_GENERATION_VALUES)
        url.searchParams.append(
          "host",
          meetingClient?.envConfig.DOMAIN_HOSTNAME
        )
        const response = await axios.get(url.toString(), {
          withCredentials: true
        })
        return response.data
      }
    })
    return data as ChatGenerationValue[]
  }

  const putChatGenerationValue = async (cgv: ChatGenerationValue) => {
    const meetingClient = await sdkContextStatus
    const url = new URL(meetingClient?.envConfig.CHAT_GENERATION_VALUES)
    url.searchParams.append("host", meetingClient?.envConfig.DOMAIN_HOSTNAME)
    try {
      const response = axios.put(url.toString(), cgv, { withCredentials: true })
      return response.then(() => queryClient.invalidateQueries(QUERY_KEY))
    } catch (err) {
      console.error(err)
      throw err
    }
  }

  return {
    getChatGenerationValues,
    putChatGenerationValue
  }
}
